var React = require('react');

function StatusOpening (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h23v23H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"key":0},[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"d":"M11.5 0C5.159 0 0 5.157 0 11.5 0 17.84 5.159 23 11.5 23 17.84 23 23 17.84 23 11.5 23 5.157 17.84 0 11.5 0","fill":"#8BC53F","mask":"url(#b)","key":1})]),React.createElement("path",{"d":"M15.959 7.173l-6.13 6.72-2.39-2.39a.885.885 0 0 0-1.251 1.25l3.699 3.7 7.38-8.088a.884.884 0 0 0-1.308-1.192","fill":"#FFF","key":1})])]);
}

StatusOpening.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = StatusOpening;

StatusOpening.default = StatusOpening;
